const TedShareIcon = () => (
  <div>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1900_43856)">
        <path
          d="M5.75404 6.95888C5.37096 6.19421 4.58007 5.66927 3.66659 5.66927C2.37792 5.66927 1.33325 6.71394 1.33325 8.0026C1.33325 9.29127 2.37792 10.3359 3.66659 10.3359C4.58007 10.3359 5.37096 9.811 5.75404 9.04633M5.75404 6.95888C5.91137 7.27293 5.99992 7.62743 5.99992 8.0026C5.99992 8.37778 5.91137 8.73228 5.75404 9.04633M5.75404 6.95888L10.2458 4.713M5.75404 9.04633L10.2458 11.2922M10.2458 4.713C10.6289 5.47767 11.4198 6.0026 12.3333 6.0026C13.6219 6.0026 14.6666 4.95794 14.6666 3.66927C14.6666 2.38061 13.6219 1.33594 12.3333 1.33594C11.0446 1.33594 9.99992 2.38061 9.99992 3.66927C9.99992 4.04445 10.0885 4.39894 10.2458 4.713ZM10.2458 11.2922C10.0885 11.6063 9.99992 11.9608 9.99992 12.3359C9.99992 13.6246 11.0446 14.6693 12.3333 14.6693C13.6219 14.6693 14.6666 13.6246 14.6666 12.3359C14.6666 11.0473 13.6219 10.0026 12.3333 10.0026C11.4198 10.0026 10.6289 10.5275 10.2458 11.2922Z"
          stroke="#2A60DF"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1900_43856">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);
export default TedShareIcon;
